import type { GraphQLError } from 'graphql';

const ignoredErrors = [
  { message: /NetworkError when attempting to fetch resource/ },
  { type: 'TypeError', message: /Failed to fetch/ },
  { type: 'TypeError', message: 'Load failed' },
  { type: 'TypeError', message: /The network connection was lost./ },
  { type: 'TypeError', message: /A ligação de rede foi cortada./ },
  { type: 'TypeError', message: /Połączenie sieciowe zostało przerwane./ },
  { type: 'TypeError', message: /Połączenie z Internetem jest chyba rozłączone./ },
  { type: 'TypeError', message: /Nie można było znaleźć serwera z podaną nazwą hosta./ }, // safari issue
  { type: 'TypeError', message: /anulat/ },
  { type: 'TypeError', message: /anulowane/ },
  { type: 'TypeError', message: /annulé/ },
  { type: 'TypeError', message: /cancelled/ },
  { type: 'TypeError', message: /Nie można było połączyć z serwerem/ },
  { type: 'TypeError', message: /imposibil de prelucrat răspunsul/ },
  {
    type: 'TypeError',
    message:
      /(undefined is not a constructor \(evaluating 'new Intl\.DisplayNames|Intl\.DisplayNames is not a constructor)/,
  },
  { type: 'ChunkLoadError', message: /Loading chunk/ },
  { type: 'Error', message: /^Unknown error$/ },
  { message: /was aborted/i },
  { message: /network error/i },
  { message: /user aborted/i },
  { message: /Websocket error: abnormal closure/i },
  { message: /AbortError: Fetch is aborted/i },
  { message: /AbortError: Request signal is abortedd/i },
];

export const shouldIgnoreError = (error: Error): boolean => {
  if (error.name || error.message) {
    return ignoredErrors.some(({ type, message }) => {
      if (type && error.name && type !== error.name) {
        return false;
      }

      return !!error.message?.match(new RegExp(message, 'i'));
    });
  }

  return false;
};

const ignoredGraphQLErrorMessages = ['unauthorized', 'temporarily unavailable'];

export const shouldIgnoreGraphQLError = (error: GraphQLError): boolean =>
  !!error.message &&
  ignoredGraphQLErrorMessages.some((message) => error.message?.match(new RegExp(message, 'i')));
